import { getGeoListFromLocation, getGeoListFromAddress } from "@/utils/helpers";
import { Button, Card, Flex, Modal, ScrollArea, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconSearch } from "@tabler/icons-react";
import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";

export default function LocationFinder({ disabled = false, title, selectItem, companyId, style }) {
  const [opened, { open, close }] = useDisclosure();
  const [openedPartner, { open: openPartner, close: closePartner }] = useDisclosure();
  const [addressInput, setAddressInput] = useState("");
  const [resultList, setResultList] = useState([]);

  const form = useForm({
    initialValues: {
      name: "",
      address: "",
      addressDetail: "",
      lat: "",
      lng: "",
      managerName: "",
      managerPhoneNumber: "",
      manager1: "",
      manager2: "",
      manager3: "",
      manager4: "",
      manager5: "",
    },
    validate: {
      name: (x) => !x && "거래처명을 입력해주세요",
      address: (x) => !x && "거래처 주소를 입력해주세요",
    },
  });

  async function handleSearch() {
    const [res, res2] = await Promise.all([getGeoListFromLocation(addressInput), getGeoListFromAddress(addressInput)]);

    const finalArr = [...res2, ...res];

    if (finalArr.length > 0) {
      setResultList(finalArr);
    } else {
      toast.error("일치하는 장소가 없습니다");
    }
  }

  function handleSelect(item) {
    const { name, address, lat, lng, phone } = item;
    selectItem({ name, address, lat, lng, phone });
    setAddressInput("");
    setResultList([]);
    close();
  }

  function openPartnerAddModal(item) {
    const { name, address, lat, lng, phone } = item;
    form.setValues({
      name,
      address,
      lat,
      lng,
      managerPhoneNumber: phone,
    });

    close();
    setAddressInput("");
    setResultList([]);

    openPartner();
  }

  async function addToPartnerAndSelectItem() {
    const { name, address, lat, lng, phone, managerName, managerPhoneNumber, addressDetail } = form.values;
    await axios({
      url: "/partners",
      method: "POST",
      data: {
        data: {
          ...form.values,
          lat: parseFloat(form.values.lat),
          lng: parseFloat(form.values.lng),
          company: companyId,
          type: "unload",
        },
      },
    });
    form.reset();
    toast.success("거래처 등록 완료");
    selectItem({ name, address, lat, lng, phone, managerName, managerPhoneNumber, addressDetail });
  }

  return (
    <>
      <Button
        onClick={open}
        fullWidth
        color="violet"
        style={style}
        disabled={disabled}
        leftIcon={<IconSearch size={18} />}
      >
        {title}
      </Button>

      <Modal opened={opened} onClose={close} title={title} scrollAreaComponent={ScrollArea.Autosize} size="md">
        <Flex mt="sm" gap="sm">
          <TextInput
            mb={0}
            sx={{ flex: 4 }}
            value={addressInput}
            data-autofocus
            placeholder="검색하고자 하는 장소 입력"
            onChange={(e) => setAddressInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && addressInput) {
                // prevent form submission
                e.preventDefault();
                handleSearch();
              }
            }}
          />
          <Button onClick={handleSearch} sx={{ flex: 1 }}>
            장소 검색
          </Button>
        </Flex>

        {resultList.length === 0 && (
          <Card shadow="0" padding="xl" py={150} mt="sm">
            <Text ta="center" size="sm" color="dimmed">
              검색하고자 하는 장소를 입력해주세요
            </Text>
          </Card>
        )}

        <ScrollArea>
          {resultList.map((result, idx) => (
            <Flex gap="sm" mt="sm" key={result.address + idx}>
              <Card
                shadow="0"
                padding="xs"
                radius="sm"
                style={{ cursor: "pointer", flex: 1 }}
                bg="#f9fafc"
                onClick={() => handleSelect(result)}
              >
                <Text fw={700} lineClamp={1} size="sm">
                  {result.name}
                </Text>
                <Text size="sm" mt={2}>
                  {result.address}
                </Text>
                <Text size="sm" mt={2}>
                  {result.phone || "-"}
                </Text>
              </Card>
              {companyId && (
                <Button
                  size="xs"
                  h="auto"
                  onClick={() => openPartnerAddModal(result)}
                  variant="light"
                  ta="center"
                  lh={1.6}
                >
                  거래처
                  <br />
                  목록
                  <br />
                  추가
                </Button>
              )}
            </Flex>
          ))}
        </ScrollArea>
      </Modal>

      <Modal
        opened={openedPartner}
        onClose={closePartner}
        title="거래처 목록에 추가"
        scrollAreaComponent={ScrollArea.Autosize}
      >
        <TextInput label="거래처명" placeholder="거래처명을 입력해주세요" {...form.getInputProps("name")} mb="sm" />

        <TextInput
          mt="sm"
          label="거래처 주소"
          placeholder="거래처 주소를 입력해주세요"
          {...form.getInputProps("address")}
          mb="sm"
          disabled
        />

        <TextInput
          mt="sm"
          label="거래처 세부주소"
          placeholder="거래처 세부주소를 입력해주세요"
          {...form.getInputProps("addressDetail")}
          mb="sm"
        />

        <TextInput
          mt="sm"
          label="담당자명"
          placeholder="담당자명을 입력해주세요"
          {...form.getInputProps("managerName")}
        />

        <TextInput
          label="담당자 전화번호"
          placeholder="담당자 전화번호를 입력해주세요"
          {...form.getInputProps("managerPhoneNumber")}
        />

        <Button onClick={addToPartnerAndSelectItem} fullWidth color="violet" sx={{ flex: 1 }}>
          저장
        </Button>
      </Modal>
    </>
  );
}
